import React from "react";
import { Heart, Zap, Users, Globe } from "lucide-react";
import "../styles/about.css";

export default function AboutPage() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <img src="/images/Afriportstore.png" alt="Afriport Brand Logo" style={{ height: 75, width: "auto", objectFit: "contain", marginBottom: 16 }} />
          <h1>About Afriport</h1>
          <p>Your trusted marketplace for electronics, solar power, furniture &amp; lifestyle essentials</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-section">
        <div className="container">
          <h2>Our Mission</h2>
          <p>
            Afriport is dedicated to empowering African businesses and entrepreneurs by providing a seamless digital marketplace where quality products and services can reach customers across the continent and beyond. We believe in supporting local businesses while delivering exceptional value to our customers.
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="about-section bg-light">
        <div className="container">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <Heart className="value-icon" />
              <h3>Trust & Integrity</h3>
              <p>We prioritize transparency and ethical practices in every transaction.</p>
            </div>
            <div className="value-card">
              <Zap className="value-icon" />
              <h3>Innovation</h3>
              <p>We continuously improve our platform to enhance user experience.</p>
            </div>
            <div className="value-card">
              <Users className="value-icon" />
              <h3>Community</h3>
              <p>We support local entrepreneurs and foster business growth across Africa.</p>
            </div>
            <div className="value-card">
              <Globe className="value-icon" />
              <h3>Global Reach</h3>
              <p>We connect African businesses with customers worldwide.</p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer */}
      <section className="about-section">
        <div className="container">
          <h2>What We Offer</h2>
          <div className="offers-list">
            <div className="offer-item">
              <h3>Wide Product Selection</h3>
              <p>Browse thousands of products from trusted sellers across Africa</p>
            </div>
            <div className="offer-item">
              <h3>Secure Payments</h3>
              <p>Multiple payment options with secure transactions</p>
            </div>
            <div className="offer-item">
              <h3>Fast Delivery</h3>
              <p>Reliable shipping with order tracking</p>
            </div>
            <div className="offer-item">
              <h3>Seller Support</h3>
              <p>Comprehensive tools and support for business sellers</p>
            </div>
            <div className="offer-item">
              <h3>Customer Protection</h3>
              <p>Buyer protection policies and responsive customer support</p>
            </div>
            <div className="offer-item">
              <h3>Easy Returns</h3>
              <p>Hassle-free return policies for customer satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="about-section bg-light">
        <div className="container">
          <h2>Get in Touch</h2>
          <p style={{ marginBottom: "2rem", textAlign: "center" }}>
            Have questions? We'd love to hear from you!
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "2rem", flexWrap: "wrap" }}>
            <div style={{ textAlign: "center" }}>
              <h4>Email</h4>
              <p>support@afriportb2c.online</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <h4>Phone</h4>
              <p>+234 915 589 6484</p>
            </div>
            <div style={{ textAlign: "center" }}>
              <h4>WhatsApp</h4>
              <p>+234 915 589 6484</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
